import { useContext } from "react";
import useTranslator from "../../hooks/useTranslator";
import AuthContext from "../../context/auth/AuthContext";
import { PeopleList, ProgressRail, StepList } from "../../components/design";
import "./guarantorOnboardingProgress.css";

export default function CoTenantOnboardingProgress({
  step,
  coTenantName,
  originalUser,
  coTenants = undefined,
  applicationProfiles = undefined,
  activeApplicationProfileEmail = undefined,
}) {
  const { _t } = useTranslator();
  const { user } = useContext(AuthContext);

  const activeName =
    coTenantName || user?.fname || _t("co_tenant", "Co-tenant");
  const displayCoTenants = coTenants?.length
    ? coTenants
    : [{ name: activeName, status: "active" }];
  const isApplicationProfileFlow = Boolean(applicationProfiles?.length);

  // Details(1) Identity(2) Documents(3-5) Financial(6)
  const profileSteps = [
    { id: "details", title: _t("onboardingDetails", "Details") },
    { id: "identity", title: _t("onboardingIdentity", "Identity") },
    { id: "documents", title: _t("onboardingDocuments", "Documents") },
    {
      id: "financial",
      title: _t("onboardingFinancialStudy", "Financial study"),
      badge: _t("onboardingRecommended", "Recommended"),
    },
  ];
  const activeProfileIndex = (() => {
    if (step === 1) return 0;
    if (step === 2) return 1;
    if (step >= 3 && step <= 5) return 2;
    if (step === 6) return 3;
    return 0;
  })();

  const people = [
    ...(isApplicationProfileFlow
      ? []
      : [
          {
            key: "you",
            initial: (originalUser?.fname || "Y").charAt(0).toUpperCase(),
            name: _t("you", "You"),
            status: _t("profileCompleted", "Profile completed"),
            complete: true,
          },
        ]),
    ...(isApplicationProfileFlow ? applicationProfiles : displayCoTenants).map(
      (g) => {
        const isActive = isApplicationProfileFlow
          ? g.email === activeApplicationProfileEmail
          : g.name === activeName;
        const completed = isApplicationProfileFlow
          ? g.onboarding_status === "COMPLETED"
          : g.completed;
        return {
          key: g.email || g.name,
          initial: g.name.charAt(0).toUpperCase(),
          name:
            isApplicationProfileFlow && g.is_lead ? _t("you", "You") : g.name,
          status: isActive
            ? _t(
                "youAreCompletingTheirProfile",
                "You're completing their profile"
              )
            : completed
              ? _t("profileCompleted", "Profile completed")
              : _t("notStarted", "Not started"),
          active: isActive,
          complete: !!completed,
        };
      }
    ),
  ];

  return (
    <ProgressRail
      className="guarantor-onboarding-progress"
      label={_t("coTenantProgress", "Co-tenant progress")}
      steps={profileSteps}
      activeIndex={activeProfileIndex}
    >
      <p className="onboarding-progress__eyebrow">
        {_t("guarantorProgressEyebrowApplication", "THE APPLICATION")}
      </p>
      <PeopleList people={people} />
      <p className="onboarding-progress__eyebrow">
        {_t("coTenantProfileEyebrow", "{{name}}'S PROFILE", undefined, {
          name: activeName.toUpperCase(),
        })}
      </p>
      <StepList steps={profileSteps} activeIndex={activeProfileIndex} />
    </ProgressRail>
  );
}
